module.exports = __webpack_public_path__ + "img/hopways.b832f455.webp";